export default __webpack_public_path__ + "static/github-webhook-913ca879dbf1a1d6186be7b132ef2b11.png";